var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert-box alert" },
    [
      _vm.isTypeString()
        ? [_vm._v("\n        " + _vm._s(_vm.errors) + "\n    ")]
        : [
            _vm._l(_vm.errors, function(error_field) {
              return [
                _vm._l(error_field, function(error) {
                  return [
                    _vm._v(
                      "\n                " + _vm._s(error) + "\n            "
                    )
                  ]
                })
              ]
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7877f6de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7877f6de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/components/ui/errors.vue
// module id = 13
// module chunks = 0 2 3 4 5 6 7 8 9 10